import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import config from 'devextreme/core/config';
import App from './App';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import '@jarvis/platform-ui/tokens.css';
import '@jarvis/platform-ui/styles.css';
import './app.css';
import { bootstrapTheme } from './theme/useThemeStore';

bootstrapTheme();

const licenseKey = import.meta.env.VITE_DEVEXTREME_LICENSE_KEY;
if (licenseKey) {
  config({ licenseKey });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>
);
